document.addEventListener("click", function (event) {
  const trigger = event.target.closest(".size_guide_popup_trigger");

  if (trigger) {
    event.preventDefault();

    const productId = trigger.dataset.sizeGuideId;
    const popup = document.querySelector(`[data-size-guide-popup="${productId}"]`);

    if (!popup) return;

    popup.style.display = "block";
    document.querySelector("[data-site-overlay]")?.classList.add("show");
    document.body.classList.add("body-hidden");
    return;
  }

  const closeButton = event.target.closest(".size-guide_popup_close");

  if (closeButton) {
    event.preventDefault();

    const popup = closeButton.closest(".size-guide_popup");

    if (!popup) return;

    popup.style.display = "none";
    document.querySelector("[data-site-overlay]")?.classList.remove("show");
    document.body.classList.remove("body-hidden");
    return;
  }

  const tab = event.target.closest(".size_guide_nav_item");

  if (tab) {
    event.preventDefault();

    const popup = tab.closest(".size-guide_popup");
    if (!popup) return;

    const unit = tab.classList.contains("metric") ? "metric" : "imperial";

    popup.querySelectorAll(".size_guide_nav_item").forEach((item) => {
      item.classList.remove("active");
    });

    popup.querySelectorAll(".size_guide_table").forEach((table) => {
      table.classList.remove("active");
    });

    tab.classList.add("active");
    popup.querySelector(`.size_guide_table_${unit}`)?.classList.add("active");
  }
});